import { EDeviceSize } from "constants/media";
import { useState, useLayoutEffect } from "react";

const useMediaQuery = (query: keyof typeof EDeviceSize | Omit<string, keyof typeof EDeviceSize>): boolean => {
    const [matches, setMatches] = useState(false);

    useLayoutEffect(() => {
        if (!window) return;

        setMatches(window.matchMedia(query as string).matches);
    }, [query]);

    useLayoutEffect(() => {
        const mediaQueryList = window.matchMedia(query as string);

        const handleChange = (event: MediaQueryListEvent) => {
            setMatches(event.matches);
        };

        mediaQueryList.addEventListener("change", handleChange);

        setMatches(mediaQueryList.matches);

        return () => {
            mediaQueryList.removeEventListener("change", handleChange);
        };
    }, [query]);

    return matches;
};

export default useMediaQuery;
